import React, { useState } from 'react'
import {
    Stack,
    Alert,
} from '@mui/material'
import {ArrowRight} from "../icons/Icons";
import {Nullable} from "../../utils/UtilityTypes";
import {PresetSelector} from "./PresetSelector";
import {Time} from "../../time/DateTime";
import {TimePicker} from "./TimePicker";


export interface TimeRange{
    startTime: Time | null,
    endTime: Time | null
}

const TimeRangePicker = ({
                             onTimeRangeChange,
                             showPresets = true,
                             label = "Select Time Range"
                         }) => {
    const [timeRange, setTimeRange] = useState<Nullable<TimeRange>>({
        startTime: null,
        endTime: null
    })

    const [error, setError] = useState('')

    const handleTimeChange = (label, value: Time|null) => {
        const newTimeRange : Nullable<TimeRange> = { ...timeRange, [label]: value }
        setTimeRange(newTimeRange)

        // Validate time range
        if (newTimeRange.startTime && newTimeRange.endTime) {
            const startMinutes = timeToMinutes(newTimeRange.startTime as Time)
            const endMinutes = timeToMinutes(newTimeRange.endTime as Time)

            if (startMinutes >= endMinutes) {
                setError('End time must be after start time')
            } else {
                setError('')
                onTimeRangeChange(newTimeRange)
            }
        } else {
            onTimeRangeChange(newTimeRange)
        }
    }

    const timeToMinutes = (time: Time) => {
        return parseInt(time.hour) * 60 + parseInt(time.minute)
    }

    const applyPreset = (timeRange: TimeRange) => {
        setTimeRange(timeRange)
        setError('')
        onTimeRangeChange(timeRange)
    }

    const presets = [
        {label: 'Morning', value: {startTime: Time.fromString('09:00'), endTime: Time.fromString('12:00')}},
        {label: 'Afternoon', value: {startTime: Time.fromString('13:00'), endTime: Time.fromString('17:00')}},
        {label: 'Evening', value: {startTime: Time.fromString('18:00'), endTime: Time.fromString('21:00')}},
        {label: 'Full Day', value: {startTime: Time.fromString('09:00'), endTime: Time.fromString('17:00')}}
    ];
    return (
        <Stack spacing={3}>
            {/* Main Time Selection */}
            <div>
                <header>
                    {label}
                </header>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" sx={{ mb: 2 }}>
                    <TimePicker value={timeRange.startTime} label="Start time picker" onChange={(f)=> handleTimeChange('startTime', f)}/>
                    <ArrowRight/>
                    <TimePicker value={timeRange.endTime} label="End time picker" onChange={(f)=> handleTimeChange('endTime', f)} />
                </Stack>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
            </div>

            {showPresets && <PresetSelector presets={presets} onSelect={applyPreset}/>}
        </Stack>
    )
}

export default TimeRangePicker